module.exports = __webpack_public_path__ + "img/placeholder-img.9e3f64ea.jpg";